import styled from 'styled-components';
import { titillium15 } from '@virgilsecurity/virgil-ui/src/lib/fonts';

export const Button = styled.a`
	${titillium15}
	cursor: pointer;
	transition: all 0.2s;
`;
